var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visibility
    ? _c(
        "div",
        {
          staticClass:
            "chart section section-border--top section-border--right section-border--bottom",
        },
        [
          _c(
            "div",
            { staticClass: "chart__top" },
            [
              _c("TitleBlock", {
                staticClass: "chart-title",
                attrs: {
                  text: _vm.title,
                  color: "default",
                  "tip-text": _vm.tipText,
                  chart: true,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("highchart", {
            attrs: {
              options: _vm.chartOptions[_vm.type],
              modules: _vm.modulesToAdd,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }